import {Directive, EventEmitter, Input, OnInit, Output, ViewContainerRef} from "@angular/core";
import {FormGroup} from "@angular/forms";
import {InputComponent} from "../input/input.component";
import {ButtonComponent} from "../button/button.component";
import {SelectComponent} from "../select/select.component";
import {DateComponent} from "../date/date.component";
import {RadiobuttonComponent} from "../radiobutton/radiobutton.component";
import {CheckboxComponent} from "../checkbox/checkbox.component";
import {ActionButtonComponent} from "../action-button/action-button.component";
import {LabelComponent} from "../label/label.component";
import {HiddenComponent} from "../hidden/hidden.component";
import {ListComponent} from "../list/list.component";
import {SelectSearchComponent} from "../select-search/select-search.component";
import {ActionLinkComponent} from "../action-link/action-link.component";
import {FieldResource} from "../../core/modules/openapi";
import {CitySearchComponent} from "../city-search/city-search.component";
import {
  VisibilityGroupSelectorComponent
} from "../visibility-group-selector/visibility-group-selector.component";
import {Observable} from "rxjs";
import {InputClientSearchComponent} from "../input-client-search/input-client-search.component";
import {CatalogDataSearchComponent} from "../catalog-data-search/catalog-data-search.component";

const componentMapper = {
  input: InputComponent,
  button: ButtonComponent,
  select: SelectComponent,
  date: DateComponent,
  radiobutton: RadiobuttonComponent,
  checkbox: CheckboxComponent,
  action_button: ActionButtonComponent,
  label: LabelComponent,
  list: ListComponent,
  hidden: HiddenComponent,
  select_search: SelectSearchComponent,
  action_link: ActionLinkComponent,
  city_search: CitySearchComponent,
  visibility_group_selector: VisibilityGroupSelectorComponent,
  input_client_search: InputClientSearchComponent,
  catalog_search: CatalogDataSearchComponent
};

@Directive({
  selector: "[dynamicField]",
  standalone: true
})
export class DynamicFieldDirective implements OnInit {
  @Input() field: FieldResource;
  @Input() group: FormGroup;
  @Input() currentVisibilityGroup: string;
  @Input() subject: Observable<string>;
  @Output() visibilityGroupChanged: EventEmitter<string> = new EventEmitter<string>();
  componentRef: any;

  constructor(
    private container: ViewContainerRef
  ) {
  }

  ngOnInit() {
    if (this.field?.type) {
      this.componentRef = this.container.createComponent(componentMapper[this.field.type as keyof typeof componentMapper]);
      this.componentRef.instance.field = this.field;
      this.componentRef.instance.subject = this.subject;
      //this.componentRef.instance.activeVisibilityGroup = this.currentVisibilityGroup;
      if (this.field.action != null) {
        this.componentRef.instance.callFunction = new Function("return " + this.field.action);
      }
      if (this.field.type === 'visibility_group_selector') {
        (this.componentRef.instance as VisibilityGroupSelectorComponent).visibilityGroupChanged.subscribe((value) => {
          this.visibilityGroupChanged.emit(value);
        });
      }
      this.componentRef.instance.group = this.group;
    }
  }
}
